import { API } from "aws-amplify";

const search = async (management_id, account_id, searchCriteria) => {
  let myInit = {
    // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: {
      // OPTIONAL
      management_id: management_id,
      account_id: account_id,
      q: searchCriteria
    }
  };
  let items = await API.get(
    "InasakuAPI",
    "/inasaku/search-work-histories",
    myInit
  );

  return items;
};

const show = async (management_id, id, account_id) => {
  let myInit = {
    // OPTIONAL
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    queryStringParameters: {
      // OPTIONAL
      management_id: management_id,
      paddy_field_id: id,
      account_id: account_id
    }
  };
  let items = await API.get("InasakuAPI", "/inasaku/work-histories", myInit);

  return items;
};

const bulkCreate = async (
  management_id,
  paddyFields,
  season,
  item,
  workItems,
  workHistoryIdMap,
  imagePaths,
  areaTotal,
  accountId,
  userId
) => {
  const paramWorkItems = {};
  for (const e in workItems) {
    if (workItems.hasOwnProperty(e)) {
      paramWorkItems[e] = workItems[e];
    }
  }

  const params = paddyFields.map(paddyField => {
    const workHistory = {
      management_id: management_id,
      paddy_field_id: paddyField.paddy_field_id,
      paddy_field_name: paddyField.name,
      item_id: item.item_id,
      item_name: item.item_name,
      season_id: season.season_id,
      season_name: season.season_name,
      work_items: paramWorkItems,
      image_paths: imagePaths
    };
    // work_history_idがあればパラメータに追加する
    if (workHistoryIdMap[paddyField.paddy_field_id]) {
      workHistory.work_history_id = workHistoryIdMap[paddyField.paddy_field_id];
    }
    return workHistory;
  });
  // for (const param of params) {
  //   let myInit = {
  //     response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
  //     body: {
  //       data: param,
  //     },
  //     headers: {}, // OPTIONAL
  //   };
  //   await API.post("InasakuAPI", "/inasaku/work-histories", myInit);
  // }
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: {
        account_id: accountId,
        user_id: userId,
        area_total: areaTotal,
        work_histories: params
      }
    },
    headers: {} // OPTIONAL
  };
  await API.post("InasakuAPI", "/inasaku/work-histories", myInit);
};

const update = async (
  management_id,
  workHistory,
  workItems,
  imagePaths,
  accountId,
  userId
) => {
  const paramWorkItems = {};
  for (const e in workItems) {
    if (workItems.hasOwnProperty(e)) {
      paramWorkItems[e] = workItems[e];
    }
  }

  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      data: {
        account_id: accountId,
        user_id: userId,
        work_history: {
          management_id: management_id,
          work_history_id: workHistory.work_history_id,
          paddy_field_id: workHistory.paddy_field_id,
          paddy_field_name: workHistory.paddy_field_name,
          item_id: workHistory.item_id,
          item_name: workHistory.item_name,
          season_id: workHistory.season_id,
          season_name: workHistory.season_name,
          work_items: paramWorkItems,
          image_paths: imagePaths
        }
      }
    },
    headers: {} // OPTIONAL
  };

  let res = await API.put(
    "InasakuAPI",
    `/inasaku/work-histories/${workHistory.work_history_id}`,
    myInit
  );

  return res;
};

const del = async (management_id, work_history_id, accountId, userId) => {
  let myInit = {
    response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
    body: {
      management_id: management_id,
      work_history_id: work_history_id,
      account_id: accountId,
      user_id: userId
    },
    headers: {} // OPTIONAL
  };
  let res = await API.del(
    "InasakuAPI",
    `/inasaku/work-histories/${work_history_id}`,
    myInit
  );

  return res;
};

export default {
  search: search,
  show: show,
  bulkCreate: bulkCreate,
  update: update,
  del: del
};
